import {
  FormControl,
  Autocomplete,
  TextField,
} from '@mui/material';
import {
  FieldValues,
  FieldPath,
  useController,
} from 'react-hook-form';
import './index.scss';
import { TAutoCompleteProps } from '../controllerTypes';

export function AutoCompleteController<
  TFieldValues extends FieldValues = FieldValues,
  TFieldName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
  control,
  name,
  label,
  required,
  options = [],
  placeholder = `Select ${label?.toLowerCase()}`,
  error,
  disabled,
  locked,
  onChange,
  isDefaultValueNull,
  disableClearable,
  disablePortal = true,
  height,
}: TAutoCompleteProps<TFieldValues, TFieldName>) {
  const { field } = useController({
    control,
    name,
    disabled,
  });
  // const value = field.value;
  // if (disabled && value) {
  //   options = [
  //     {
  //       value: value,
  //       label: `${value}`,
  //     },
  //   ];
  // }
  const getSelectedValue = () => {
    return (
      options?.find(
        (ele) =>
          ele?.value?.toString().toLowerCase() ==
          field.value?.toString().toLowerCase()
      ) || null
    );
  };

  return (
    <FormControl
      fullWidth
      className="h-28 form-control_autocomplete">
      {label && (
        <label className="form-field-label">
          {label}
          {required && <i className="required">*</i>}
        </label>
      )}
      <Autocomplete
        className="custom-autocomplete"
        sx={{
          '& .MuiInputBase-root': {
            height: height ? height : 50,
          },
        }}
        id={`auto-complete-${name}`}
        options={options}
        disablePortal={disablePortal}
        {...field}
        disabled={locked || field.disabled}
        value={getSelectedValue()}
        onChange={(_event, selectedOption) => {
          onChange
            ? onChange(selectedOption)
            : field.onChange(
                isDefaultValueNull
                  ? selectedOption?.value || null
                  : selectedOption?.value
              );
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={placeholder}
          />
        )}
        renderOption={(props, option) => (
          <li
            {...props}
            key={
              option?.key
                ? option.key
                : option.value?.toString()
            }
            style={{
              fontSize: '13px',
              color: option.disabled ? 'gray' : 'inherit', // Gray out disabled options
              pointerEvents: option.disabled
                ? 'none'
                : 'auto', // Disable selection
              opacity: option.disabled ? 0.5 : 1, // Reduce opacity for disabled options
            }}
            aria-disabled={option.disabled} // Mark as disabled for accessibility
          >
            {option?.label}
          </li>
        )}
        disableClearable={disableClearable}
      />
      <p
        className={`form-field-error ${
          error ? 'visible' : ''
        }`}>
        {error?.toString()}
      </p>
    </FormControl>
  );
}
